"use strict";
//@ts-nocheck
/**
 * Handle forms
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
const _main_1 = require("./_main");
_main_1.txGs1Base.forms = {
    initialize: function () {
        'use strict';
        _main_1.txGs1Base.forms.select.initialize();
        _main_1.txGs1Base.forms.buttons.initialize();
        _main_1.txGs1Base.forms.datamintsFeuser.initialize();
        _main_1.txGs1Base.forms.powermail.initialize();
        _main_1.txGs1Base.forms.async.initialize();
    }
};
exports.default = {};
